import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { StoreSection } from "../../../../redux/services/store/storeCategoryPagesApi";

type Props = {
  section: StoreSection;
};

const PromoBannerSection: React.FC<Props> = ({ section }) => {
  const items = (section.items || []).filter((item) => item.is_active !== false);

  if (!items.length) return null;

  return (
    <section className="section">
      <Container fluid>
        <Row className="g-4">
          {items.map((item) => {
            const content = item.content_json || {};

            return (
              <Col key={item.id} lg={content.col_lg || 6} md={content.col_md || 6}>
                <div
                  className={`rounded-3 overflow-hidden position-relative ${content.wrapper_class || ""}`}
                  style={{
                    backgroundImage: content.image_url
                      ? `url(${content.image_url})`
                      : undefined,
                    backgroundSize: content.background_size || "cover",
                    backgroundPosition: content.background_position || "center",
                    backgroundRepeat: "no-repeat",
                    minHeight: content.min_height || "260px",
                    padding: content.padding || "40px",
                  }}
                >
                  {content.title ? (
                    <h3 className={content.title_class || "mb-2 text-white"}>
                      {content.title}
                    </h3>
                  ) : null}

                  {content.subtitle ? (
                    <p className={content.subtitle_class || "mb-3 text-white"}>
                      {content.subtitle}
                    </p>
                  ) : null}

                  {content.button_text ? (
                    <Link
                      to={content.button_link || "#"}
                      className={content.button_class || "btn btn-light"}
                    >
                      {content.button_text}
                    </Link>
                  ) : null}
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default PromoBannerSection;